import * as React from 'react';
import styled from 'styled-components';
import { SecondaryButton } from '../ui-kit/Buttons';

const Container = styled.div`
  position: relative;
  padding: 80px 3%;
`;
const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
`;
const FixedBackground = styled.div`
  position: absolute;
  left: 0%;
  top: auto;
  right: 0%;
  bottom: 0%;
  z-index: -1;
  height: 50%;
  background: ${({ theme }) => theme.palette.background.contrast};
`;
const Banner = styled.div`
  background: ${({ theme }) => theme.palette.primary.main};
  padding: 25px 70px;
  border-radius: 24px;
  min-height: 280px;

  color: ${({ theme }) => theme.palette.text.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    font-size: 40px;
    font-weight: 500;
    &:first-child {
      color: ${({ theme }) => theme.palette.primary.light};
    }
    @media (max-width: 768px) {
      font-size: 28px;
    }
  }
  button {
    min-width: 143px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: auto;
    padding: 35px 30px;
    min-height: auto;
  }
`;
const BannerText = styled.p`
  color: ${({ theme }) => theme.palette.text.white};
  margin-top: 25px;
  max-width: 450px;
  font-size: 18px;
  line-height: 1.51;
  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

const GetInTouchBanner = () => {
  return (
    <Container>
      <Wrapper>
        <Banner>
          <div>
            <h1>That’s it! </h1>
            <h1>Now it’s your turn to say hi.</h1>
            <BannerText>
              Do you want to work together or talk about an idea? Lets get in touch then. Just drop
              me a line!
            </BannerText>
          </div>
          <SecondaryButton>
            <a href="mailto:paulclindo@gmail.com" target="_blank" rel="noreferrer">
              Get In Touch
            </a>
          </SecondaryButton>
        </Banner>
        <FixedBackground />
      </Wrapper>
    </Container>
  );
};

export default GetInTouchBanner;
